import React from 'react';
import { CheckIcon } from 'lucide-react';
import { pricing } from '../data/masterclass';
export function Pricing() {
  return <section aria-labelledby="pricing-heading" className="border-t border-ink-line bg-ink" id="pricing" data-id="element-98" data-mp="2aqj5pjswb8jo">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-99" data-mp="2oktkb8b6hmc0">
        <div className="text-center" data-id="element-100" data-mp="2jkxldnhc8l3b">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-101" data-mp="2jlyx7u66hbm3">
            Investment
          </p>
          <h2 id="pricing-heading" className="mt-4 font-display text-4xl font-bold uppercase text-white sm:text-5xl" data-id="element-102" data-mp="1rsyei62nrxvw">
            Choose your experience
          </h2>
        </div>

        <div className="mt-14 grid items-stretch gap-6 sm:grid-cols-2" data-id="element-103" data-mp="20s3d1ce7zr82">
          {pricing.map(tier => <div key={tier.name} className={`flex flex-col rounded-2xl border p-8 ${tier.featured ? 'border-gold bg-gold/[0.06]' : 'border-ink-line bg-ink-soft'}`} data-id="element-104" data-mp="3h63amgplf4s5">
              <div className="flex items-start justify-between gap-3" data-id="element-105" data-mp="4smcsm635vwo">
                <h3 className="font-display text-xl font-semibold uppercase leading-tight text-white" data-id="element-106" data-mp="9s8sr3datq96">
                  {tier.name}
                </h3>
                {tier.featured && <span className="shrink-0 rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-107" data-mp="eoz8tqp3slul">
                    Complete plan
                  </span>}
              </div>

              <div className="mt-6 flex items-end gap-2" data-id="element-108" data-mp="3n6ljwmgrwr3a">
                <span className="font-display text-6xl font-bold leading-none text-gold" data-id="element-109" data-mp="3n524ey2xyk2k">
                  {tier.price}
                </span>
                <span className="pb-1 text-sm uppercase tracking-[0.12em] text-white/50" data-id="element-110" data-mp="2uj99fanw09qc">
                  {tier.unit}
                </span>
              </div>

              <p className="mt-4 leading-relaxed text-white/60" data-id="element-111" data-mp="2zf7twn63h7lh">
                {tier.description}
              </p>

              <ul className="mb-8 mt-6 space-y-2.5" data-id="element-112" data-mp="2mi1k1eyxhtae">
                {tier.perks.map(perk => <li key={perk} className="flex items-start gap-3 text-white/75" data-id="element-113" data-mp="316ejwn14zwa6">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-114" data-mp="2w7l60thxu39h" />
                    <span data-id="element-115" data-mp="28iipxq2ycih3">{perk}</span>
                  </li>)}
              </ul>

              <a href={tier.url} target="_blank" rel="noopener noreferrer" className={`mt-auto inline-flex items-center justify-center rounded-full px-7 py-4 text-center text-sm font-bold uppercase tracking-[0.12em] transition-[transform,background-color,color] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold ${tier.featured ? 'bg-gold text-ink hover:bg-gold-pale' : 'border border-gold text-gold hover:bg-gold hover:text-ink'}`} data-id="element-116" data-mp="23kgwcb7wh0rd">
                {tier.cta}
              </a>
            </div>)}
        </div>

        <p className="mt-8 text-center text-sm text-white/45" data-id="element-117" data-mp="3rfww9sd97qrz">
          Secure checkout. After payment, you’ll receive your Zoom registration and
          workbook by email.
        </p>
      </div>
    </section>;
}